import 'arrayq';

import { nextNode, prevNode } from '../domop';

const TEXT_NODE = 3;

export class NodeTextNavigation {
    private _currentOffset: number;
    private _currentNodeText: string;
    private _currentDomNode: Node;

    constructor(node: Node) {
        this._currentOffset = 0;
        this._currentNodeText = this.getNodeText(node);
        this._currentDomNode = node;
    }

    public getNodeText(domNode: Node) {
        return (domNode && domNode.nodeType === TEXT_NODE && domNode.textContent) || '';
    }

    public next() {
        return this.forward(this._currentNodeText.length - this._currentOffset);
    }
    public start() {
        this._currentOffset = 0;
        return this;
    }
    public end() {
        this._currentOffset = this._currentNodeText.length;
        return this;
    }

    public forward(characters: number) {
        let timeout = 1000000;
        while (this._currentDomNode && (characters > 0 || !this._currentNodeText)) {
            if (timeout-- < 0) {
                // tslint:disable-next-line
                console.error('NodeTextNavigation: Too many iterations.');
                throw Error('NodeTextNavigation: Too many iterations.');
            }

            if (this._currentNodeText) {
                const max = this._currentNodeText.length - this._currentOffset;
                const advance = Math.min(max, characters);
                if (advance > 0) {
                    characters -= advance;
                    this._currentOffset += advance;
                }
            }

            // At the end? Move to the next node.
            if (this._currentOffset === this._currentNodeText.length) {
                this._currentDomNode = nextNode(this._currentDomNode);
                this._currentNodeText = this.getNodeText(this._currentDomNode);
                this._currentOffset = 0;
            }
        }
        return this;
    }
    public backward(characters: number) {
        let timeout = 1000000;
        while (this._currentDomNode && (characters > 0 || !this._currentNodeText)) {
            if (timeout-- < 0) {
                // tslint:disable-next-line
                console.error('NodeTextNavigation: Too many iterations.');
                throw Error('NodeTextNavigation: Too many iterations.');
            }

            if (this._currentNodeText) {
                const max = this._currentOffset;
                const advance = Math.min(max, characters);
                if (advance > 0) {
                    characters -= advance;
                    this._currentOffset -= advance;
                }
            }

            // At the start? Move to the previous node.
            if (this._currentOffset === 0) {
                this._currentDomNode = prevNode(this._currentDomNode);
                this._currentNodeText = this.getNodeText(this._currentDomNode);
                this._currentOffset = this._currentNodeText.length;
            }
        }
        return this;
    }
    public countBackwards(node: Node): number {
        let count = 0;
        while (this._currentDomNode && this._currentDomNode !== node) {
            count += this._currentOffset;
            this._currentDomNode = prevNode(this._currentDomNode);
            this._currentNodeText = this.getNodeText(this._currentDomNode);
            this._currentOffset = this._currentNodeText.length;
        }
        if (this._currentDomNode === node) {
            count += this._currentOffset;
            this._currentOffset = 0;
        }
        return count;
    }
    public countForwards(node: Node): number {
        let count = 0;
        while (this._currentDomNode && this._currentDomNode !== node) {
            count += this._currentNodeText.length - this._currentOffset;
            this._currentDomNode = prevNode(this._currentDomNode);
            this._currentNodeText = this.getNodeText(this._currentDomNode);
            this._currentOffset = 0;
        }
        return count;
    }
    public domNode(): Node {
        return this._currentDomNode;
    }
    public offset(): number {
        return this._currentOffset;
    }
    public text(): string {
        return this._currentNodeText;
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/NodeTextNavigation.tsx